import { AddUserFormInputs, AddUserInput } from '../../../types/Forms';
import ValidationForm from '../../formsAndTable/forms/formControls/formValidation/validationForm';

type AddUserFormProps = {
  inputs: AddUserInput[];
  formTitle: string;
  formSubTitle: string;
  submitHandler: (data: any) => void;
  defaultValues: Partial<AddUserFormInputs>;
  mode: 'create' | 'edit';
  subject: "user" | "course" | "feedback";
  coursesList?: {
    label: string;
    value: string;
   
  }[];
};

const AddUserForm = ({
  inputs,
  formTitle,
  formSubTitle,
  submitHandler,
  defaultValues,
  mode,
  subject,
  coursesList
}: AddUserFormProps) => {
  return (
    <>
      <ValidationForm<AddUserFormInputs>
        inputs={inputs}
        formTitle={formTitle}
        formSubTitle={formSubTitle}
        submitHandler={submitHandler}
        defaultValues={defaultValues}
        mode={mode}
        subject={subject}
        coursesList={coursesList}
      />
    </>
  );
};

export default AddUserForm;
